var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 162",
    style: {
      enableBackground: "new 0 0 512 162"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430,85.32c-2.12,2.27-3.95,4.94-6.41,6.76c-21.24,15.74-42.58,31.35-63.91,46.96 c-5.85,4.28-13.09,2.1-14.76-4.41c-0.31-1.23-0.29-2.56-0.3-3.84c-0.02-11.73-0.01-23.46-0.01-35.2c0-1.08,0-2.16,0-3.68 c-1.42,0-2.67,0-3.92,0c-6.16,0-12.33,0.06-18.49-0.03c-5.17-0.07-9.19-4.17-9.09-9.09c0.1-4.85,4.01-8.74,9.08-8.8 c7.34-0.08,14.68-0.02,22.42-0.02c0-1.27,0-2.33,0-3.38c0-11.93,0.05-23.86-0.03-35.79c-0.03-4.01,1.17-7.24,4.82-9.2 c3.81-2.05,7.23-1.04,10.54,1.38c21.78,16.01,43.61,31.95,65.34,48.04c1.9,1.4,3.16,3.67,4.72,5.53C430,82.13,430,83.73,430,85.32z  M362.68,114.55c14.59-10.7,28.72-21.07,43.12-31.63c-14.5-10.63-28.63-20.99-43.12-31.61C362.68,72.58,362.68,93.24,362.68,114.55z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.66,91.84c-4.37,0-8.75,0.05-13.12-0.01c-5.26-0.08-9.18-3.97-9.17-8.98c0.01-5,3.94-8.89,9.22-8.93 c8.84-0.07,17.69-0.07,26.53,0c5.3,0.04,9.12,3.9,9.11,8.98c-0.01,5.06-3.86,8.86-9.16,8.93C155.61,91.89,151.14,91.84,146.66,91.84 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.01,73.89c4.27,0,8.55-0.04,12.82,0.01c5.46,0.07,9.37,3.95,9.29,9.13c-0.08,5.02-3.98,8.76-9.33,8.79 c-8.74,0.05-17.49,0.05-26.23,0c-5.35-0.03-9.22-3.78-9.28-8.83c-0.05-5.2,3.82-9.02,9.32-9.09 C264.07,73.85,268.54,73.89,273.01,73.89z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.69,91.84c-4.37,0-8.74,0.05-13.12-0.01c-5.26-0.07-9.23-3.92-9.28-8.88c-0.05-4.97,3.91-8.98,9.13-9.02 c8.94-0.07,17.89-0.08,26.83,0.01c5.04,0.05,8.95,4.03,9.01,8.87c0.05,4.93-3.96,8.94-9.15,9.03 C218.64,91.9,214.16,91.84,209.69,91.84z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.48,91.84c-4.37,0-8.75,0.05-13.12-0.01c-5.26-0.08-9.18-3.97-9.17-8.98c0.01-5,3.94-8.89,9.22-8.93 c8.84-0.07,17.69-0.07,26.53,0c5.3,0.04,9.12,3.9,9.11,8.98c-0.01,5.06-3.86,8.86-9.16,8.93C95.43,91.89,90.96,91.84,86.48,91.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadArrow);
export default __webpack_public_path__ + "static/media/road-arrow.56e4a95ceb185c676dddad1ffee86fd5.svg";
export { ForwardRef as ReactComponent };